import React from "react";
import cn from "classnames";

import styles from "./Text.module.scss";

type TextHTMLTag =
    "a"
    | "div"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "p"
    | "span";

type TextStyle =
    "button-text"
    | "cta"
    | "heading-1"
    | "heading-2"
    | "heading-3"
    | "heading-4"
    | "heading-5"
    | "serif-body"
    | "sans-serif-body"
    | "sans-serif-body-small";

interface TextProps {
    htmlTag?: TextHTMLTag;
    textStyle: TextStyle;
    children?: React.ReactNode;
}

const textHTMLTags: TextHTMLTag[] = [
    "a",
    "div",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "p",
    "span"
];

const textStyles: TextStyle[] = [
    "button-text",
    "cta",
    "heading-1",
    "heading-2",
    "heading-3",
    "heading-4",
    "heading-5",
    "serif-body",
    "sans-serif-body",
    "sans-serif-body-small"
];

const Text = (props: TextProps & Record<string, any>) => {
    const {
        htmlTag: Tag = "div", textStyle, className = "", children, ...restProps
    } = props;

    // Will default to div if no HTML Tag is passed in
    return (
        <Tag className={cn(className, styles[textStyle])} {...restProps}>
            {children}
        </Tag>
    );
};

export {
    Text as default, textStyles, textHTMLTags
};
export type { TextProps, TextStyle, TextHTMLTag };
